import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppHypotheekbondNewCondition = (): DescribeNodeType =>
  'een nieuw Hypotheekbond event binnenkomt';

export default describeAppHypotheekbondNewCondition;
